/**
 * Helpers shared by every non-product-form path that adds to the cart:
 * the in-cart upsell, the cart swap row, and the post-ATC upsell popup.
 */

/**
 * Collects section IDs from all cart-items-component elements on the page.
 * @returns {string} Comma-separated section IDs
 */
export function getCartSectionIds() {
  const ids = new Set();
  document.querySelectorAll('cart-items-component').forEach((el) => {
    if (el instanceof HTMLElement && el.dataset.sectionId) {
      ids.add(el.dataset.sectionId);
    }
  });
  return Array.from(ids).join(',');
}

/**
 * Resolves the new TOTAL cart item count after an add.
 *
 * cart-icon.js sets the header bubble to `itemCount` for non product-form
 * sources, and the drawer now updates via hydration (which never re-renders the
 * header bubble). So we must pass the real total here, not the quantity added,
 * or the badge would show "1" regardless of cart size.
 *
 * @param {Record<string, string>|undefined} sections - Rendered sections from the cart/add response.
 * @returns {number} The new total cart item count.
 */
export function getNewCartCount(sections) {
  // Authoritative: the count rendered into the returned section(s).
  if (sections) {
    for (const html of Object.values(sections)) {
      const text = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('[ref="cartItemCount"]')
        ?.textContent?.trim();
      if (text) return parseInt(text, 10);
    }
  }

  // Fallback: increment the currently displayed header count by the 1 unit added.
  const current = parseInt(document.querySelector('[ref="cartBubbleCount"]')?.textContent ?? '0', 10);
  return (Number.isNaN(current) ? 0 : current) + 1;
}
